import React from "react";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import { TemplateTaskPanel } from "./TemplateTaskPanel.jsx";

export const TemplateTaskFormPanelContainer = ({ fieldRef, ...rest }) => {
  const { values, setValues } = useFormikContext();
  const handleChange = (updates) => {
    setValues((prevValues) => ({ ...prevValues, ...updates }));
  };
  return (
    <TemplateTaskPanel
      task={values}
      onChange={handleChange}
      fieldRef={fieldRef}
      isForm
      {...rest}
    />
  );
};

TemplateTaskFormPanelContainer.propTypes = {
  fieldRef: PropTypes.object,
};
